import React from 'react';

// Styles
import './InstructionsTitle.scss';

type Props = {
  title: string;
  titleTag?: 'h5' | 'p';
  description: string;
};

const InstructionsTitle = ({ title, titleTag = 'h5', description }: Props) => {
  const Tag = titleTag;
  const baseClassName = 'InstructionsTitle';

  return (
    <div className={baseClassName}>
      <Tag className={`${baseClassName}__title`}>{title}</Tag>
      <p className={`${baseClassName}__description`}>{description}</p>
    </div>
  );
};

export default InstructionsTitle;
